export default class Config {
    /**
     * 基础域名（从环境变量读取）
     */
    private static readonly BASE_DOMAIN = (process.env.VUE_APP_BASE_DOMAIN as string);

    /**
     * API接口（基于基础域名自动生成）
     */
    public static readonly API_HOST: string = `https://${this.BASE_DOMAIN}/api/`;

    /**
     * 中心服务器域名（基于基础域名自动生成）
     */
    public static readonly hubUrl: string = `https://${this.BASE_DOMAIN}/chat/`;
}